import React from 'react';

export const EventsHeader = ({ events }) => {
  // Calculate total stats
  const getStats = () => {
    return {
      totalEvents: events.length,
      needsReview: events.filter(e => e.alarmStatus === 'PENDING').length,
      confirmedAlarms: events.filter(e => e.alarmStatus === 'CONFIRMED').length,
      falseAlarms: events.filter(e => e.alarmStatus === 'FALSE').length
    };
  };

  // Get recent activities - only CONFIRMED and FALSE alarms
  const getRecentActivities = () => {
    return events
      .filter(e => e.alarmStatus === 'CONFIRMED' || e.alarmStatus === 'FALSE')
      .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
      .slice(0, 3);
  };

  const stats = getStats();

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Event Monitor</h1>
      </div>

      <div className="flex gap-6">
        {/* Stats Grid */}
        <div className="grid grid-cols-3 gap-4 flex-grow">
          <div className="bg-amber-50 rounded-lg border border-amber-200 p-4 shadow-sm">
            <div className="text-sm text-amber-800 mb-1">Needs Review</div>
            <div className="text-2xl font-bold text-amber-900">{stats.needsReview}</div>
          </div>

          <div className="bg-red-50 rounded-lg border border-red-200 p-4 shadow-sm">
            <div className="text-sm text-red-800 mb-1">Confirmed Alarms</div>
            <div className="text-2xl font-bold text-red-900">{stats.confirmedAlarms}</div>
          </div>

          <div className="bg-green-50 rounded-lg border border-green-200 p-4 shadow-sm">
            <div className="text-sm text-green-800 mb-1">False Alarms</div>
            <div className="text-2xl font-bold text-green-900">{stats.falseAlarms}</div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="w-80 bg-white rounded-lg border border-gray-200 p-4 shadow-sm">
          <h2 className="text-lg font-semibold mb-3 text-gray-900">Recent Activity</h2>
          <div className="space-y-3">
            {getRecentActivities().map(activity => (
              <div key={activity._id} className="flex items-center gap-3 bg-gray-50 p-2 rounded-md">
                <span className="text-xl">
                  {activity.alarmStatus === 'CONFIRMED' ? '🚨' : 
                   activity.alarmStatus === 'FALSE' ? '✓' : ''}
                </span>
                <div>
                  <div className="text-sm text-gray-900">
                    {`Alarm marked as ${activity.alarmStatus === 'CONFIRMED' ? 'confirmed' : 'false'}`}
                  </div>
                  <div className="text-xs text-gray-500">
                    {new Date(activity.timestamp).toLocaleTimeString()}
                  </div>
                </div>
              </div>
            ))}
            {getRecentActivities().length === 0 && (
              <div className="text-sm text-gray-500 text-center py-2">
                No recent alarm activities
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};